import { axiosHyperwolfClient } from "axiosClient";
import axiosClientHyperDrive from "axiosClient/indexHyperdrive";
import axiosClientHyperWolf from "axiosClient/indexHyperWolf";
import { getQueryString } from "utilities/common";

// Main Setting API
export async function getTransportAPI() {
    return await axiosClientHyperWolf.get('api/v1/transportationTypes/get');
}

export async function updateTransportStatusAPI(data, transportId) {
    return await axiosClientHyperWolf.put(`api/v1/transportationTypes/${transportId}`, data);
}

export async function getChecklistApi() {
    return await axiosClientHyperWolf.get('api/v1/checklist/list');
}

export async function getCheckoutlistApi() {
    return await axiosClientHyperDrive.get('api/v1/admin/closeout/list');
}

export async function addChecklistDataAPI(data) {
    return await axiosClientHyperDrive.post('api/v1/admin/outOfService/add', data);
}

export async function getChecklistDataDetailsApi(reasonId) {
    return await axiosClientHyperDrive.get(`api/v1/admin/outOfService/show/${reasonId}`);
}

export async function deleteCheckListApi(deleteCheckList) {
    return await axiosClientHyperDrive.delete(`api/v1/admin/outOfService/delete/${deleteCheckList}`);
}

export async function updateCheckOutListStatusAPI(data, checklistId) {
    return await axiosClientHyperDrive.put(`api/v1/admin/closeout/update/${checklistId}`, data);
}

export async function updateCheckListStatusAPI(data, checklistId) {
    return await axiosClientHyperWolf.put(`api/v1/checklist/update/${checklistId}`, data);
}

export async function getFailureReasonApi() {
    return await axiosClientHyperWolf.get('api/v1/failureReason/list');
}

export async function addFailureReasonApi(data) {
    return await axiosClientHyperWolf.post('api/v1/failureReason/add', data);
}

export async function getFailureReasonDetailsApi(reasonId) {
    return await axiosClientHyperWolf.get(`api/v1/failureReason/show/${reasonId}`);
}

export async function editFailureReasonApi(data, reasonId) {
    return await axiosClientHyperWolf.put(`api/v1/failureReason/edit/${reasonId}`, data);
}


export async function deleteFailureReasonApi(deleteFailureReason) {
    return await axiosClientHyperWolf.delete(`api/v1/failureReason/delete/${deleteFailureReason}`);
}

export async function getAnnouncementsApi() {
    return await axiosClientHyperWolf.get('api/v1/announcement/list');
}

export async function addAnnouncementApi(data) {
    return await axiosClientHyperWolf.post('api/v1/announcement/add', data);
}

export async function getAnnouncementDetailsApi(reasonId) {
    return await axiosClientHyperWolf.get(`api/v1/announcement/show/${reasonId}`);
}

export async function editAnnouncementApi(data, announcementId) {
    return await axiosClientHyperWolf.put(`api/v1/announcement/edit/${announcementId}`, data);
}

export async function deleteAnnouncementsApi(deleteAnnouncements) {
    return await axiosClientHyperWolf.delete(`api/v1/announcement/delete/${deleteAnnouncements}`);
}

export async function getOutofServiceApi() {
    return await axiosClientHyperDrive.get('api/v1/admin/outOfService/list');
}

export async function addOutofServiceApi(data) {
    return await axiosClientHyperDrive.post('api/v1/admin/outOfService/add', data);
}

export async function getOutofServiceDetailsApi(reasonId) {
    return await axiosClientHyperDrive.get(`api/v1/admin/outOfService/show/${reasonId}`);
}

export async function editOutofServiceApi(data, reasonId) {
    return await axiosClientHyperDrive.put(`api/v1/admin/outOfService/edit/${reasonId}`, data);
}


export async function deleteOutofServiceApi(deleteOutofService) {
    return await axiosClientHyperDrive.delete(`api/v1/admin/outOfService/delete/${deleteOutofService}`);
}

export async function fetchBufferRulesAPI(reasonId) {
    return await axiosHyperwolfClient.get(`api/v1/hyperdrive/region/assignment`);
}

export async function editBufferRulesAPI(data) {
    return await axiosHyperwolfClient.put(`api/v1/hyperdrive/assign/distance`, data);
}


export async function getRoutingConfigDetailsApi(data) {
    return await axiosClientHyperDrive.get(`api/v1/admin/rankConfig`);
}

export async function updateRoutingConfigDetailsApi(data) {
    return await axiosClientHyperDrive.post(`api/v1/admin/rankConfig`, data);
}

export async function updateOrderStatusApiHit(data) {
    return await axiosClientHyperDrive.post(`api/v1/common/update/order/status`, data);
}

export async function updateDriverStatusApiHit(data) {
    return await axiosClientHyperDrive.post(`api/v1/common/update/fleet`, data);
}

export async function updateDriverTasksApiHit(data) {
    return await axiosClientHyperDrive.get(`api/v1/common/task/list?fleetId=${data}`);
}

export async function fetchDriverScoreApiHit(data) {
    return await axiosClientHyperDrive.post(`api/v1/common/driver/score`, data);
}

export async function placeOrderApiHit(data) {
    return await axiosClientHyperWolf.post(`api/v1/partner/store/cart/custom/submit`, data);
}

export async function orderApiSubmitHit(data) {
    return await axiosClientHyperWolf.post(`api/v1/orders`, data);
}

export async function fetchLocationRegionApiAHit(data) {
    return await axiosClientHyperWolf.get(`api/v1/hyperdrive/fetch/web/regions?${getQueryString(data)}`);
}


export async function fetchTerminalQuanitityApiHit(data) {
    return await axiosClientHyperWolf.get(`api/v1/hyperdrive/terminal/quantities/${data}`);
}


export async function editTimeSimulationHit(data) {
    return await axiosClientHyperDrive.post(`api/v1/common/update/time`, data);
}

export async function getScheduleCroneApiHit(data) {
    if (data === 'start') {
        return await axiosClientHyperDrive.get(`api/v1/common/start/task`);
    }
    else {
        return await axiosClientHyperDrive.get(`api/v1/common/schedule/task`);
    }

}


export async function getKmlDataApiHit(data) {
    return await axiosClientHyperWolf.get(`api/v1/hyperdrive/active/regions/coordinates`, data);
}